import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRealtimeParticipant, useRealtimeParticipants } from '../hooks/useRealtime'
import { HUDLayout } from '../components/hud/HUDLayout'
import { Timer } from '../components/ui/Timer'
import { LapCounter } from '../components/hud/LapCounter'
import { PositionIndicator } from '../components/hud/PositionIndicator'
import { MiniMap } from '../components/hud/MiniMap'
import { SpeedGauge } from '../components/hud/SpeedGauge'

export function HUDPage() {
  const [searchParams] = useSearchParams()
  const participantId = searchParams.get('participant') || ''
  const raceId = searchParams.get('race') || ''
  const [raceElapsed, setRaceElapsed] = useState(0)

  const { participant } = useRealtimeParticipant(participantId)
  const { participants } = useRealtimeParticipants(raceId)

  useEffect(() => {
    const interval = setInterval(() => {
      setRaceElapsed((prev) => prev + 10)
    }, 10)
    return () => clearInterval(interval)
  }, [])

  if (!participant) {
    return (
      <div className="w-full h-screen bg-gradient-to-br from-palm-dark to-[#0f1419] flex items-center justify-center">
        <div className="text-center text-gray-400 font-quicksand">
          <p className="text-xl mb-2">Loading pilot HUD...</p>
          <p className="text-sm">Participant ID: {participantId}</p>
        </div>
      </div>
    )
  }

  const totalParticipants = participants.length || 1

  return (
    <HUDLayout
      title="PILOT HUD"
      boatColor={participant.boat_color}
      boatNumber={participant.boat_number}
    >
      <div className="h-full flex flex-col gap-8">
        {/* Main Timer - Center Top */}
        <div className="text-center">
          <div className="text-sm uppercase text-gray-400 font-quicksand mb-4">
            Race Time
          </div>
          <Timer
            elapsed={raceElapsed}
            isActive={participant.status === 'racing'}
            size="lg"
          />
        </div>

        {/* Grid Layout */}
        <div className="grid grid-cols-3 gap-8 flex-1">
          {/* Left: Position Indicator */}
          <div className="flex items-center justify-center">
            <PositionIndicator
              position={participant.current_position}
              totalParticipants={totalParticipants}
            />
          </div>

          {/* Center: Speed Gauge */}
          <div className="flex items-center justify-center">
            <SpeedGauge value={Math.random() * 100} label="Speed" />
          </div>

          {/* Right: Lap Counter */}
          <div className="flex items-center justify-center">
            <LapCounter
              currentLap={participant.total_laps}
              totalLaps={10}
            />
          </div>
        </div>

        {/* Bottom: Mini Map */}
        <div className="border-t border-tropical-green border-opacity-30 pt-6">
          <MiniMap
            participants={participants}
            currentParticipantId={participantId}
          />
        </div>

        {/* Lap Stats */}
        <div className="grid grid-cols-2 gap-4 border-t border-tropical-green border-opacity-30 pt-6">
          <div className="text-center">
            <div className="text-xs uppercase text-gray-400 font-quicksand mb-2">
              Best Lap
            </div>
            <div className="text-2xl font-fredoka font-700 text-tropical-green">
              {participant.best_lap_time
                ? `${(participant.best_lap_time / 1000).toFixed(3)}s`
                : '--:--.-'}
            </div>
          </div>

          <div className="text-center">
            <div className="text-xs uppercase text-gray-400 font-quicksand mb-2">
              Last Lap
            </div>
            <div className="text-2xl font-fredoka font-700 text-paradise-blue">
              {participant.last_lap_time
                ? `${(participant.last_lap_time / 1000).toFixed(3)}s`
                : '--:--.-'}
            </div>
          </div>
        </div>
      </div>
    </HUDLayout>
  )
}
